import React, { PureComponent } from 'react';
import { connect } from 'unistore/react';
import classnames from 'classnames';
import stickybits from 'stickybits';

import { is768Query } from '~/core/scripts/mediaquery-helper'
import { Actions } from '../../Store';
import SliderComponent from '~/core/scripts/components/Slider';
import { startYearSelector } from '../../Selectors';

import './Slider.styl';

class Slider extends PureComponent {
  constructor() {
    super();

    this.isInitialized = false;
  }

  handleChange = value => {
    this.props.setDataIndex(value);
  }

  componentDidUpdate() {
    if (!this.isInitialized && this.props.data) {
      if (is768Query() && this.props.isBeforeElection) {
        stickybits('.eu2019-slider', { useStickyClasses: true });
      }
      this.isInitialized = true;
    }
  }

  render() {
    const { data, dataIndex, isBeforeElection, startYear } = this.props;

    if (!data) {
      return null;
    }

    const currentLabel = isBeforeElection ? 'aktuell' : '2019';

    const marks = data.reduce((res, curr, i) => {
      res[i] = i === data.length - 1 ? currentLabel : curr.startYear;
      return res;
    }, {});

    const sliderClasses = classnames('eu2019-slider', {
      'before-election': isBeforeElection
    });

    return (
      <div className={sliderClasses}>
        <div className="slider-headline">Europawahl {startYear}</div>
        <SliderComponent
          included={false}
          marks={marks}
          min={0}
          max={data.length - 1}
          onChange={this.handleChange}
          value={dataIndex}
          onBeforeChange={() => this.props.setDragging(true)}
          onAfterChange={() => this.props.setDragging(false)}
        />
      </div>
    );
  }
}

export default connect(state => ({
  data: state.data,
  dataIndex: state.dataIndex,
  isBeforeElection: state.isBeforeElection,
  startYear: startYearSelector(state)
}), Actions)(Slider);
